// import RequestWrapper from 'core/service/advisorzone-middleware/request-wrapper'
import { requestWrapper } from 'e-submission/domain/data'

const MaturityValidateApi = () => {
  const getMaturityStatus = ({ user, maturityIDCard, productCode, pathURL }) => {
    const data = {
      productCode: productCode,
      customerIdCard: maturityIDCard,
    }
    return requestWrapper.postRequest(pathURL, user, data).then(({ data }) => data)
  }

  return {
    getMaturityStatus: (user, maturityIDCard, productCode) => getMaturityStatus(user, maturityIDCard, productCode),
  }
}

export default MaturityValidateApi()
